
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/reference/elements/[reference-id]",
      function () {
        return require("private-next-pages/docs/reference/elements/[reference-id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/reference/elements/[reference-id]"])
      });
    }
  